import DAO from "../../DAO/DAO";

export function setPermissions(permissions) {
	let user = DAO.user.get();

	if (permissions) {
		const aclRules = [];

		Object.keys(permissions).forEach(permission => {
			const rules = permissions[permission];

			if (typeof rules === "boolean") {
				aclRules.push(permission);
			} else {
				Object.keys(rules).forEach(rule => {
					if (rules[rule]) {
						aclRules.push(permission + rule);
					}
				});
			}
		});

		if (user) {
			user.permissions = permissions;
			user.rules = aclRules;

			DAO.user.set(user);
		} else {
			DAO.user.set({
				permissions,
				rules: aclRules
			});
		}
	}
}

export function getPermissions() {
	let user = DAO.user.get();

	if (user) {
		const { permissions } = user;

		if (permissions) {
			return permissions;
		}
	}

	return null;
}

export function getRules() {
	let user = DAO.user.get();

	if (user) {
		const { rules } = user;

		if (rules && rules.length) {
			return rules;
		}
	}

	return "public";
}

export function hasPermission(rules) {
	if (!rules) {
		return false;
	}

	const userRules = getRules();

	if (userRules === "public") {
		if (typeof rules === "string") {
			return userRules === rules;
		}

		return rules.includes(userRules);
	}

	if (typeof rules === "string") {
		return userRules.some(userRule => {
			return userRule === rules;
		});
	}

	return userRules.some(userRule => {
		return rules.find(rule => {
			return userRule === rule;
		});
	});
}
